import { TableCell } from '@mui/material'
import { Box, styled } from '@mui/system'

export const StyledStickyHourCell = styled(TableCell)(({ theme }) => ({
  width: '60px !important',
  borderRight: '1px solid',
  borderColor: theme.palette.background.elevation4,
  borderBottom: 'none',
  color: theme.palette.text.base,
  backgroundColor: theme.palette.background.elevation1,
  position: 'sticky',
  left: 0,
  zIndex: 4,
}))

export const StyledStickyAvatarCell = styled(TableCell)(({ theme }) => ({
  padding: '0px 8px',
  borderRight: '1px solid',
  borderBottom: 'none',
  borderColor: theme.palette.background.elevation4,
}))

export const StyledHourCell = styled(TableCell)(({ theme }) => ({
  width: '60px !important',
  height: '44px !important',
  borderRight: '1px solid',
  borderBottom: '0px',
  borderColor: theme.palette.background.elevation4,
  position: 'sticky',
  left: 0,
  zIndex: 3,
  backgroundColor: theme.palette.background.elevation1,
}))

export const StyledCell = styled(TableCell)(({ theme }) => ({
  borderRight: '1px solid',
  borderBottom: '1px solid',
  height: '60px',
  borderColor: theme.palette.background.elevation4,
  paddingTop: '0px',
  paddingBottom: '0px',
}))

export const StyledLeaderTableCell = styled(TableCell)(({ theme }) => ({
  borderRight: '1px solid',
  borderBottom: '1px solid',
  height: '45px !important',
  borderColor: theme.palette.background.elevation4,
  padding: '0px 8px',
}))

interface StyledBoxProps {
  isWorkingTimeBar?: boolean
}

export const StyledWorkRangeBar = styled(Box, {
  shouldForwardProp: prop => prop !== 'isWorkingTimeBar',
})<StyledBoxProps>(({ theme, isWorkingTimeBar }) => ({
  backgroundColor: isWorkingTimeBar ? theme.palette.primary.light : '#03a9f4',
  opacity: isWorkingTimeBar ? '50%' : '20%',
  minWidth: '15px',
  maxWidth: '30px',
  width: '100%',
  borderRadius: '10px',
  zIndex: 2,
  position: 'absolute',
  '&:hover': {
    opacity: '100%',
  },
}))

export const StyledWorkRangeBox = styled(Box)(({ theme }) => ({
  minWidth: '15px',
  maxWidth: '30px',
  width: '100%',
  height: '100%',
  position: 'relative',
}))